export default {
  names: {
    email: 'E-mail',
    password: 'Senha',
    confirmPassword: 'Confirmar senha',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    newEmail: 'Novo Email',
    confirmEmail: 'Confirmar Novo Email',
    newPassword: 'Nova Senha'
  }
}
